import React from 'react';
import { Box, Typography } from '@mui/material';
import type { StyleLevel } from '../../types';

interface StyleLevelBadgeProps {
  level: StyleLevel;
  size?: 'small' | 'medium' | 'large';
}

const SIZES = { small: { h: 28, fs: '0.65rem', icon: '0.8rem' }, medium: { h: 34, fs: '0.75rem', icon: '1rem' }, large: { h: 42, fs: '0.85rem', icon: '1.2rem' } };

/**
 * StyleLevelBadge — visual badge showing the user's current style tier with gradient.
 */
const StyleLevelBadge: React.FC<StyleLevelBadgeProps> = ({ level, size = 'medium' }) => {
  const s = SIZES[size];
  const gradient = `linear-gradient(135deg, ${level.gradientColors[0]}, ${level.gradientColors[1]})`;

  return (
    <Box sx={{
      display: 'inline-flex', alignItems: 'center', gap: 0.5,
      background: gradient, borderRadius: 99, px: 1.5, height: s.h,
    }}>
      <Typography component="span" sx={{ fontSize: s.icon }}>{level.icon}</Typography>
      <Typography component="span" sx={{ color: '#fff', fontWeight: 700, fontSize: s.fs, whiteSpace: 'nowrap' }}>
        {level.label}
      </Typography>
    </Box>
  );
};

export default StyleLevelBadge;
